"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3503],{

/***/ 94053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ Badge; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _Typography_index_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71323);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25989);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17016);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const BadgeWrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div`
  position: relative;
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F}
`;
const StyledBadge = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(({ theme, top, right, color }) => `
  min-width: ${theme.spacing.s16};
  height: ${theme.spacing.s16};
  padding: ${theme.spacing.s0} ${theme.spacing.s4};
  background: ${color ? color : theme.colors.error500};
  border-radius: ${theme.borderRadius.m};
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: ${top ? typeof top === "number" ? `${top}px` : top : 0};
  right: ${right ? typeof right === "number" ? `${right}px` : right : 0};
  transform: translate(50%,-50%);
  transform-origin: 100% 0;
`);
const StyledCaption = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Caption */ .YS)`
  text-align: center;
`;
const Badge = (_a) => {
  var _b = _a, {
    count,
    offset,
    overflowCount = 99,
    showZero = false,
    color,
    children
  } = _b, rest = __objRest(_b, [
    "count",
    "offset",
    "overflowCount",
    "showZero",
    "color",
    "children"
  ]);
  const displayCount = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    return count < 0 ? 0 : overflowCount && count > overflowCount ? `${overflowCount}+` : count;
  }, [count, overflowCount]);
  const [top, right] = offset ? offset : [];
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BadgeWrapper, __spreadValues({}, rest), children, (count > 0 || count === 0 && showZero) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledBadge, {
    top,
    right,
    color
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCaption, {
    level: 3,
    color: "white"
  }, displayCount)));
};




/***/ }),

/***/ 48673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ MenuOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32600);


const MenuOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 512 512" },
    child: [
      { tag: "title", attr: {}, child: [] },
      {
        tag: "line",
        attr: {
          x1: "88",
          y1: "152",
          x2: "424",
          y2: "152",
          fill: "none",
          stroke: "#000",
          strokeLinecap: "round",
          strokeMiterlimit: "10",
          strokeWidth: "48px"
        }
      },
      {
        tag: "line",
        attr: {
          x1: "88",
          y1: "256",
          x2: "424",
          y2: "256",
          fill: "none",
          stroke: "#000",
          strokeLinecap: "round",
          strokeMiterlimit: "10",
          strokeWidth: "48px"
        }
      },
      {
        tag: "line",
        attr: {
          x1: "88",
          y1: "360",
          x2: "424",
          y2: "360",
          fill: "none",
          stroke: "#000",
          strokeLinecap: "round",
          strokeMiterlimit: "10",
          strokeWidth: "48px"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 22236:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ ListTile; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55271);



var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div((props) => `
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: ${props.selected ? "#f5f5f5" : "#fff"};
    padding: 0.6rem;
    cursor: ${props.onClick ? "pointer" : ""};
    &:hover {
      background-color: ${props.type !== "search-suggestion" && "#f5f5f5"};
    }
  `);
const Title = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${(props) => props.numberOfLine};
  overflow: hidden;
  margin: 0 0.6rem;
  flex: 1;
`;
const ListTile = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_a, ref) => {
  var _b = _a, {
    leading,
    title,
    trailing,
    numberOfLine = 1,
    onClick,
    onMouseEnter,
    type,
    selected = false
  } = _b, props = __objRest(_b, [
    "leading",
    "title",
    "trailing",
    "numberOfLine",
    "onClick",
    "onMouseEnter",
    "type",
    "selected"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadProps(__spreadValues({
    ref,
    selected,
    onMouseEnter
  }, props), {
    onClick,
    type
  }), leading, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Title, {
    numberOfLine
  }, title), trailing);
});
ListTile.displayName = "ListTile";




/***/ }),

/***/ 12416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ Logo; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16204);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Logo = (_a) => {
  var _b = _a, {
    variant = "full",
    logoFull,
    logoLite,
    alt
  } = _b, props = __objRest(_b, [
    "variant",
    "logoFull",
    "logoLite",
    "alt"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .E, __spreadValues({
    src: variant === "full" ? logoFull : logoLite,
    alt
  }, props));
};




/***/ }),

/***/ 97061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ Text; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79690);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55271);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const getColor = (props) => {
  const { color, theme } = props;
  return color && (theme.brand[color] || theme.colors[color]) || color || theme.colors.dark;
};
const StyledText = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div(styled_system__WEBPACK_IMPORTED_MODULE_1__.space, (props) => {
  return `
    color: ${getColor(props)};
    font-weight: ${props.fontWeight || "400"};
    font-size: ${props.fontSize || 14}px;
    ${props.lineHeight ? ` line-height: ${props.lineHeight}px;` : ""}
    text-align: ${props.textAlign || "left"};
    overflow: hidden;
    ${props.maxLines ? `text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: ${props.maxLines};` : ""}
    ${props.textTransform ? `
      text-transform: ${props.textTransform};
    ` : ""}
  `;
});
const Text = (props) => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledText, __spreadValues({}, props));
};




/***/ }),

/***/ 34567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ EnhancedImage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88384);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8081);
/* harmony import */ var _helpers_image_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58754);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const EnhancedImage = (props) => {
  const _a = props, { src, googleImageParams, link, tracking } = _a, rest = __objRest(_a, ["src", "googleImageParams", "link", "tracking"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* .CustomLink */ .x, __spreadValues({}, link), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .E, __spreadProps(__spreadValues(__spreadValues({}, tracking), rest), {
    src: (0,_helpers_image_es_js__WEBPACK_IMPORTED_MODULE_3__/* .getImageUrlFromGoogleUserContent */ .N)(src, __spreadValues({
      format: "webp"
    }, googleImageParams)),
    pngSrc: (0,_helpers_image_es_js__WEBPACK_IMPORTED_MODULE_3__/* .getImageUrlFromGoogleUserContent */ .N)(src, __spreadValues({
      format: "png"
    }, googleImageParams))
  })));
};




/***/ }),

/***/ 19298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ MegaMenu; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88384);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71323);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17016);
/* harmony import */ var _MenuPanel_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74010);
/* harmony import */ var _EnhancedImage_EnhancedImage_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34567);





var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const MegaMenu = ({
  type,
  align = "left",
  menuItems
}) => {
  const [activeMenu, setActiveMenu] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(void 0);
  const verticalMenuWidth = "12.375rem";
  const horizontalMenuHeight = "3rem";
  const megaMenuHeight = "28.5rem";
  if (!menuItems.length)
    return null;
  const renderVerticalMegaMenu = () => {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MegaMenuWrapper, {
      onMouseLeave: () => {
        setActiveMenu(void 0);
      }
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(VerticalMegaMenu, {
      className: activeMenu ? "active" : "",
      width: verticalMenuWidth,
      height: megaMenuHeight
    }, menuItems.slice(0, 14).map((item, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* .CustomLink */ .x, __spreadProps(__spreadValues({}, item.link), {
      key: index
    }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(VerticalMenuItem, {
      onMouseEnter: () => {
        setActiveMenu(item);
      }
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(VerticalMenuItemImageMegaMenuWrapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_EnhancedImage_EnhancedImage_es_js__WEBPACK_IMPORTED_MODULE_2__/* .EnhancedImage */ .N, {
      src: item.icon
    })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Caption */ .YS, {
      level: 2,
      line: 1,
      style: { flex: 1 }
    }, item.name))))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(VerticalMenuPanel, {
      className: activeMenu ? "active" : "",
      type,
      verticalMenuWidth,
      menu: activeMenu
    }));
  };
  const renderHorizontalMegaMenu = () => {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MegaMenuWrapper, {
      onMouseLeave: () => {
        setActiveMenu(void 0);
      }
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(HorizontalMegaMenu, {
      height: horizontalMenuHeight,
      align
    }, menuItems.slice(0, 14).map((item, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* .CustomLink */ .x, __spreadProps(__spreadValues({}, item.link), {
      key: index
    }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(HorizontalMenuItem, {
      height: horizontalMenuHeight,
      onMouseEnter: () => {
        setActiveMenu(item);
      }
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Body */ .uT, {
      level: 2,
      line: 1,
      hoverColor: "primary500"
    }, item.name))))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(HorizontalMenuPanel, {
      type,
      className: activeMenu ? "active" : "",
      horizontalMenuHeight,
      menu: activeMenu
    }));
  };
  if (type === "vertical")
    return renderVerticalMegaMenu();
  return renderHorizontalMegaMenu();
};
const MegaMenuWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .Z.div`
  position: relative;
`;
const VerticalMenuPanel = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_MenuPanel_es_js__WEBPACK_IMPORTED_MODULE_5__/* .MenuPanel */ .G)(({
  verticalMenuWidth,
  theme
}) => `
  position: absolute;
  top: 0;
  width: calc(75rem - ${verticalMenuWidth});
  left: ${verticalMenuWidth};
  min-height: 100%;
  z-index: 980;
  overflow: hidden;
  transition: all 0.2s;
  visibility: hidden;
  opacity: 0;
  border-radius: ${theme.borderRadius.m};
  &.active {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    visibility: visible;
    opacity: 1;
  }
`);
const HorizontalMenuPanel = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_MenuPanel_es_js__WEBPACK_IMPORTED_MODULE_5__/* .MenuPanel */ .G)(({
  horizontalMenuHeight,
  theme
}) => `
  position: absolute;
  left: 0;
  right: 0;
  top: ${horizontalMenuHeight};
  z-index: 980;
  overflow: hidden;
  visibility: hidden;
  opacity: 0;
  transition: all 0.2s;
  border-bottom-right-radius: ${theme.borderRadius.m};
  border-bottom-left-radius: ${theme.borderRadius.m};
  &.active {
    visibility: visible;
    opacity: 1;
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.05));
  }
`);
const VerticalMegaMenu = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .Z.div(({ theme, width, height }) => `
  border-radius: ${theme.borderRadius.m};
  background-color: ${theme.colors.white};
  position: relative;
  overflow: hidden;
  width: ${width};
  height: ${height};
  z-index: 980;
  &.active {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
`);
const HorizontalMegaMenu = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .Z.div(({ theme, height, align }) => `
  height: ${height};
  background-color: ${theme.colors.white};
  overflow: hidden;
  width: 100%;
  ${align === "right" ? `display: flex;
        justify-content: flex-end;` : align === "space-between" ? `display: flex;
        justify-content: space-between;` : ""}
`);
const VerticalMenuItem = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .Z.div(({ theme }) => `
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: start;
  gap: ${theme.spacing.s8};
  padding: 0 ${theme.spacing.s8};
  border-radius: ${theme.borderRadius.m};
  overflow: hidden;
  &:hover {
    background-color: ${theme.colors.primary50};
    color: ${theme.colors.primary500};
  }
`);
const HorizontalMenuItem = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .Z.div(({ theme, height }) => `
  padding: 0 ${theme.spacing.s12};
  height: ${height};
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  float: left;
  position: relative;
  transition: all 0.3s ease;
  color: ${theme.colors.textPrimary};
  &::after {
    content: '';
    height: 2px;
    background-color: ${theme.colors.primary500};
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0;
    transition: all 0.3s ease;
  }
  &:hover {
    color: ${theme.colors.primary500};
    &::after {
      opacity: 1;
    }
  }
`);
const VerticalMenuItemImageMegaMenuWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .Z.div`
  width: 22px;
  height: 22px;
`;




/***/ }),

/***/ 74010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ MenuPanel; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88384);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71323);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17016);
/* harmony import */ var _helpers_megaMenu_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41753);
/* harmony import */ var _EnhancedImage_EnhancedImage_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34567);





var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const MenuPanel = ({
  menu,
  className,
  type
}) => {
  var _a, _b;
  const bannerWidth = "14.625rem";
  if (!menu || !((_a = menu.banner) == null ? void 0 : _a.src) && !menu.children.length)
    return null;
  const bannerSrc = (_b = menu.banner) == null ? void 0 : _b.src;
  const getMenuColumns = () => {
    let totalCols = 6;
    if (type === "vertical")
      totalCols--;
    if (bannerSrc)
      totalCols--;
    return totalCols;
  };
  const newMenu = (0,_helpers_megaMenu_es_js__WEBPACK_IMPORTED_MODULE_1__/* .convertMegaMenu */ .R)(menu, getMenuColumns());
  const col = (item) => {
    return item.map((it, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MenuLv2, {
      key: it.name + `-${index}`
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .CustomLink */ .x, __spreadValues({}, it.link), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .SubTitle */ .DK, {
      level: 1,
      line: 1,
      color: "primary500",
      marginBottom: "s8"
    }, it.name)), it.children.map((subItem, index2) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .CustomLink */ .x, __spreadProps(__spreadValues({}, subItem.link), {
      key: index2
    }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Text, null, subItem.name)))));
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MenuPanelWrapper, {
    className
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MenuItemsWrapper, null, newMenu.map((menu2, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Column, {
    key: index
  }, col(menu2.column)))), bannerSrc && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .CustomLink */ .x, __spreadValues({}, menu.banner.link), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_EnhancedImage_EnhancedImage_es_js__WEBPACK_IMPORTED_MODULE_4__/* .EnhancedImage */ .N, {
    src: bannerSrc,
    width: bannerWidth,
    height: "100%",
    googleImageParams: {
      width: 400
    }
  })));
};
const Text = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div */ .Z.div(({ theme }) => `
  color: ${theme.colors.textPrimary};
  margin-bottom: 4px;
  &:hover {
    color: ${theme.colors.primary500};
  }
`);
const MenuPanelWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div */ .Z.div(({ theme }) => `
  background-color: ${theme.colors.white};
  display: flex;
`);
const MenuItemsWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div */ .Z.div(({ theme }) => `
  display: flex;
  flex: 1;
  padding: ${theme.spacing.s12};
`);
const MenuLv2 = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div */ .Z.div`
  margin-bottom: 1.5rem;
`;
const Column = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div */ .Z.div`
  width: 25%;
  padding: 0 8px;
`;




/***/ }),

/***/ 58754:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ constructGoogleImageParams; },
/* harmony export */   "N": function() { return /* binding */ getImageUrlFromGoogleUserContent; }
/* harmony export */ });
const imgAttributeMapping = {
  width: "w",
  height: "h",
  webp: "rw",
  png: "rp",
  jpg: "rj",
  stretch: "s",
  crop: "c"
};
const constructGoogleImageParams = (url, config) => {
  const baseUrl = url.indexOf("=") >= 0 ? url.substring(0, url.indexOf("=")) : url;
  const params = [];
  Object.entries(config).forEach(([key, value]) => {
    if (!value)
      return;
    if (key === "format") {
      params.push(imgAttributeMapping[value]);
      return;
    }
    if (key === "size" && value) {
      params.push(`${imgAttributeMapping[key]}0`);
      return;
    }
    if (imgAttributeMapping[key]) {
      if (typeof value === "boolean") {
        if (value) {
          params.push(`${imgAttributeMapping[key]}`);
          return;
        }
        return;
      }
      params.push(`${imgAttributeMapping[key]}${value}`);
    }
  });
  return params.length > 0 ? `${baseUrl}=${params.join("-")}` : url;
};
const getImageUrlFromGoogleUserContent = (imageUrl, config) => {
  if (imageUrl && imageUrl.includes("googleusercontent.com"))
    return constructGoogleImageParams(imageUrl, config);
  return imageUrl;
};




/***/ }),

/***/ 41753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ convertMegaMenu; }
/* harmony export */ });
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const convertMegaMenu = (menu, numberCol) => {
  if (numberCol < 1)
    return;
  const newArr = menu.children.map((m) => {
    return {
      len: m.children.length + 1,
      column: [__spreadValues({}, m)]
    };
  });
  if (newArr.length <= numberCol)
    return newArr;
  newArr.sort((a, b) => b.len - a.len);
  const result = [...newArr.slice(0, numberCol)];
  let min;
  let k;
  for (let i = numberCol; i < newArr.length; i++) {
    min = result[0].len;
    k = 0;
    for (let j = 0; j < numberCol; j++) {
      if (min > result[j].len) {
        min = result[j].len;
        k = j;
      }
    }
    result[k] = {
      len: result[k].len + newArr[i].len,
      column: [...result[k].column, ...newArr[i].column]
    };
  }
  return result;
};




/***/ }),

/***/ 16204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Image; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55271);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const StyledImage = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* .styled.img */ .z.img``;
const Image = (props) => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledImage, __spreadValues({}, props));
};




/***/ }),

/***/ 84117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ SearchBar; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55271);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28247);
/* harmony import */ var _atoms_Input_Input_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89561);
/* harmony import */ var _atoms_Button_Button_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50983);
/* harmony import */ var _contexts_ThemeProvider_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80871);







var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledSearchBar = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div(({ theme, tintColor, barStyle }) => {
  const bgColor = tintColor ? tintColor : theme.colors.gray100;
  const borderRadius = `var(--search-bar-border-radius ,8px)`;
  const styles = {
    display: "flex"
  };
  switch (barStyle) {
    case "nav":
      styles["backgroundColor"] = bgColor;
      styles["borderRadius"] = "8px";
      styles[".search-icon"] = {
        backgroundColor: "transparent",
        order: -1
      };
      styles[".search-input"] = {
        paddingLeft: 0
      };
      break;
    case "light": {
      styles["backgroundColor"] = "#f6f6f6";
      styles["borderRadius"] = "8px";
      styles[".search-icon"] = {
        backgroundColor: "transparent",
        order: -1
      };
      styles[".search-input"] = {
        paddingLeft: 0
      };
      break;
    }
    default:
      styles["backgroundColor"] = bgColor;
      styles.border = `1px solid ${bgColor}`;
      styles.padding = "1px";
      styles["borderRadius"] = borderRadius;
      styles["--button-icon-border-radius"] = borderRadius;
      break;
  }
  return styles;
});
const StyledInput = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_atoms_Input_Input_es_js__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .I)`
  border: 0;
  background-color: transparent;
  flex: 1;
`;
const SearchIcon = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_atoms_Button_Button_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z)`
  height: 36px;
  width: 36px;
  border-radius: 8px;
  padding: 0;
  justify-content: center;
  border: 0;
`;
const SearchIconWrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  display: inline-block;
`;
const SearchBoxWrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  display: inline-block;
  width: 100%;
`;
const SearchBar = (_a) => {
  var _b = _a, {
    placeholder,
    prepend,
    searchIconProps,
    tintColor,
    barStyle,
    className,
    onClickIcon,
    onClickInput
  } = _b, inputProps = __objRest(_b, [
    "placeholder",
    "prepend",
    "searchIconProps",
    "tintColor",
    "barStyle",
    "className",
    "onClickIcon",
    "onClickInput"
  ]);
  const theme = (0,_contexts_ThemeProvider_es_js__WEBPACK_IMPORTED_MODULE_4__/* .useTheme */ .F)();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSearchBar, {
    tintColor,
    barStyle,
    className
  }, prepend, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SearchBoxWrapper, __spreadValues({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_5__/* .getTrackingData */ .O)({
    isTrackContent: true,
    regionName: "headerBar",
    contentName: "searchBox"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledInput, __spreadValues({
    className: "search-input",
    placeholder,
    onClick: onClickInput,
    role: "searchbox",
    "aria-label": "Search"
  }, inputProps))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SearchIconWrapper, __spreadValues({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_5__/* .getTrackingData */ .O)({
    isTrackContent: true,
    regionName: "headerBar",
    contentName: "searchButton"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SearchIcon, __spreadValues({
    onClick: onClickIcon,
    className: "search-icon",
    variant: "primary",
    "aria-label": "Search",
    icon: { name: "search", size: 26, color: theme.colors.white }
  }, searchIconProps))));
};




/***/ }),

/***/ 50290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ ModalFooter; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55271);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ModalFooter = (_a) => {
  var _b = _a, {
    children
  } = _b, props = __objRest(_b, [
    "children"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, props), children);
};
const Wrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;




/***/ }),

/***/ 17739:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ LogoHeader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20348);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(53769);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89703);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32762);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29556);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(37753);
/* harmony import */ var _teko_ecommerce__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12416);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55140);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(19298);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17016);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88384);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(48673);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28247);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  transform: translate(16px, 72px) !important;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  width: 204px;\n  border-radius: 0.5rem;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  margin-left: 0.4rem;\n  color: inherit;\n  text-decoration: inherit;\n  :hover {\n    color: inherit;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}











const LogoWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject());
const StyledLogo = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_teko_ecommerce__WEBPACK_IMPORTED_MODULE_3__/* .Logo */ .T)((param)=>{
    let { lite , height , width  } = param;
    return "\n  height: ".concat(height || 35, "px;\n  ").concat(lite ? "margin-right: 1rem; margin-left: 0.4rem; padding-right: 1rem;" : "", ";\n  width: ").concat(width ? "".concat(width, "px") : "auto", " ;\n  -webkit-transition: all .15s ease-in-out;\n  -moz-transition: all .15s ease-in-out;\n  transition: all .15s ease-in-out;\n");
});
const MenuButton = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div((param)=>{
    let { theme  } = param;
    return "\nborder: 1px solid #e0e0e0;\ncursor: pointer;\nborder-radius: 4px;\nline-height: 1rem;\npadding: 0.4rem 0.75rem;\ntext-align: center;\ncolor: ".concat(theme.colors.textSecondary, ";\n&:hover{\n  background: rgb(245, 245, 245);\n}\n");
});
const StyledDropdownMenu = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_teko_ui__WEBPACK_IMPORTED_MODULE_4__/* .DropdownMenu */ .h)(_templateObject1());
const MegaMenuWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject2());
const DummyLink = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"].a */ .Z.a(_templateObject3());
const LogoHeader = (param)=>{
    let { isLite , dropdownOpen , toggle , menuItems  } = param;
    const globalData = (0,contexts__WEBPACK_IMPORTED_MODULE_5__/* .useGlobalData */ .U5)();
    const { logo  } = (0,contexts__WEBPACK_IMPORTED_MODULE_5__/* .useTenantConfig */ .Wx)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(LogoWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .CustomLink */ .x, _objectSpreadProps(_objectSpread({
                href: "/"
            }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_7__/* .getTrackingData */ .O)({
                isTrackContent: true,
                regionName: "headerBar",
                contentName: "logoPhongVu",
                target: "homepage"
            })), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledLogo, {
                    variant: isLite ? "square" : "full",
                    lite: isLite,
                    width: logo[isLite ? "lite" : "full"].width,
                    height: logo[isLite ? "lite" : "full"].height,
                    alt: globalData.tenant,
                    logoFull: logo.full.path,
                    logoLite: logo.lite.path || logo.full.path
                })
            })),
            isLite && !!(menuItems === null || menuItems === void 0 ? void 0 : menuItems.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ui__WEBPACK_IMPORTED_MODULE_8__/* .Dropdown */ .L, {
                isOpen: dropdownOpen,
                toggle: toggle,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_9__/* .DropdownToggle */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(MenuButton, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_10__/* .MenuOutlined */ .y, {
                                    size: 20,
                                    color: "textSecondary"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DummyLink, {
                                    onClick: (evt)=>{
                                        // the purpose of this link
                                        // is to let Google crawler to follow to the categories listing.
                                        // we prevent users from actually clicking here.
                                        evt.preventDefault();
                                        return false;
                                    },
                                    href: "/categories",
                                    children: (0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)("Danh mục sản phẩm")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledDropdownMenu, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MegaMenuWrapper, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_12__/* .MegaMenu */ .V, {
                                menuItems: menuItems,
                                type: "vertical"
                            })
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 71770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ NotificationOverview; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20348);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(53769);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89703);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29556);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(37753);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(32762);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9738);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89053);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17016);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(94053);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(71323);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41036);
/* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67989);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28247);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  width: auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 10px;\n  left: calc(50% + 12px);\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










const MiniNotification = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>__webpack_require__.e(/* import() */ 2026).then(__webpack_require__.bind(__webpack_require__, 12026)).then((mod)=>mod.MiniNotification), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(12026)
            ]
    }
});
const StyledDropdown = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_teko_ui__WEBPACK_IMPORTED_MODULE_4__/* .Dropdown */ .L)(_templateObject());
const WrapperBadge = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .Z.div(_templateObject1());
const NotificationOverview = (param)=>{
    let { title =false  } = param;
    const { 0: openDropdown , 1: setOpenDropdown  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { unreadNotification  } = (0,hooks__WEBPACK_IMPORTED_MODULE_5__/* .useUnreadNotification */ .r)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledDropdown, _objectSpreadProps(_objectSpread({
        isOpen: openDropdown,
        toggle: ()=>{
            setOpenDropdown((prev)=>!prev);
        },
        toggleType: "hover",
        onHide: ()=>setOpenDropdown(false)
    }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_6__/* .getTrackingData */ .O)({
        isTrackContent: true,
        regionName: "headerBar",
        contentName: "notificationItem",
        target: "notification"
    })), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_7__/* .DropdownToggle */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_style__WEBPACK_IMPORTED_MODULE_8__/* .NavigationButton */ .W, {
                    className: "button",
                    style: {
                        flexDirection: "column",
                        minWidth: "68px"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_9__/* .NotificationsOutlined */ .Z, {
                            className: "noti",
                            size: 36,
                            color: "textSecondary"
                        }),
                        !!unreadNotification && unreadNotification > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrapperBadge, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__/* .Badge */ .C, {
                                count: unreadNotification
                            })
                        }),
                        title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__/* .Body */ .uT, {
                            level: 2,
                            weight: "medium",
                            color: "textSecondary",
                            className: "title",
                            children: (0,i18n__WEBPACK_IMPORTED_MODULE_12__.t)("Th\xf4ng b\xe1o")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_13__/* .DropdownMenu */ .h, {
                popperConfig: {
                    placement: "bottom-end"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MiniNotification, {
                    onHide: ()=>setOpenDropdown(false)
                })
            })
        ]
    }));
};


/***/ }),

/***/ 81327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ SearchBar; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(20348);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(53769);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/index.js
var react = __webpack_require__(89703);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/molecules/SearchBar/SearchBar.es.js
var SearchBar_es = __webpack_require__(84117);
// EXTERNAL MODULE: ./hooks/useSearchSuggestions.tsx
var useSearchSuggestions = __webpack_require__(91862);
// EXTERNAL MODULE: ./contexts/PopularKeywordContext.tsx
var PopularKeywordContext = __webpack_require__(63291);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/libs/styled.es.js
var styled_es = __webpack_require__(55271);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-bb101883bc/1/packages/ecommerce/dist/mobile/Text/Text.es.js
var Text_es = __webpack_require__(97061);
// EXTERNAL MODULE: ../../packages/tracking/dist/helper.es.js
var helper_es = __webpack_require__(28247);
;// CONCATENATED MODULE: ./components/desktop/organisms/RecommendedKeyword.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 4px 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  margin: 8px 0 4px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  padding-top: 4px;\n  display: flex;\n  flex-wrap: wrap;\n  background: #fff;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  height: 32px;\n  line-height: 32px;\n  padding: 0 16px;\n  border-radius: 999px;\n  background: #f5f5f5;\n  color: #333;\n  margin: 0 4px 10px 4px;\n  font-size: 14px;\n  cursor: pointer;\n\n  &:hover {\n    background-color: #ececec;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






const StyledSearchTitle = styled_es/* styled.div */.z.div(_templateObject());
const StyledRecommendedKeyword = styled_es/* styled.div */.z.div(_templateObject1());
const RecommendedKeywordWrapper = styled_es/* styled.div */.z.div(_templateObject2());
const RecommendedKeywordItem = styled_es/* styled.div */.z.div(_templateObject3());
const RecommendedKeyword = (param)=>{
    let { popularKeywords , onClick  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRecommendedKeyword, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSearchTitle, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_es/* Text */.x, {
                    fontWeight: "500",
                    textTransform: "uppercase",
                    color: "#82869E",
                    children: (0,i18n.t)("Từ kh\xf3a phổ biến")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendedKeywordWrapper, {
                children: popularKeywords.map((term, index)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendedKeywordItem, _objectSpreadProps(_objectSpread({
                        onClick: ()=>onClick(term)
                    }, (0,helper_es/* getTrackingData */.O)({
                        isTrackContent: true,
                        regionName: "popularKeyword",
                        contentName: term,
                        target: "searchProductResult",
                        payload: JSON.stringify({
                            screenName: "searchProduct",
                            index
                        })
                    })), {
                        children: term
                    }), index);
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-2db71dd60f/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/router.js
var next_router = __webpack_require__(63438);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/SvgIcon.es.js
var SvgIcon_es = __webpack_require__(46610);
;// CONCATENATED MODULE: ./components/desktop/organisms/SearchRecent.tsx
function SearchRecent_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SearchRecent_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SearchRecent_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SearchRecent_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function SearchRecent_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        SearchRecent_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function SearchRecent_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SearchRecent_templateObject() {
    const data = SearchRecent_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 4px 0;\n"
    ]);
    SearchRecent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SearchRecent_templateObject1() {
    const data = SearchRecent_taggedTemplateLiteral([
        "\n  min-width: 20px;\n"
    ]);
    SearchRecent_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






const SearchRecent_StyledSearchTitle = styled_es/* styled.div */.z.div(SearchRecent_templateObject());
const StyledSearchItem = styled_es/* styled.div */.z.div((props)=>"\n  display: flex;\n  padding: 0.6rem;\n  cursor: pointer;\n  background: ".concat(props.selected ? "#f5f5f5" : "#fff", ";\n  border-radius: 8px;\n"));
const StyledRemoveHistory = styled_es/* styled.div */.z.div((props)=>"\n  cursor: pointer;\n  color: #848788;\n  &:hover {\n    color: ".concat(props.theme.brand.primary, ";\n  }\n"));
const StyledCategoryName = styled_es/* styled.div */.z.div((props)=>"\n  color: #82869E;\n  font-size: 13px;\n  .cat-name {\n    color: ".concat(props.theme.brand.primary, ";\n  }\n"));
const StyledIcon = (0,styled_es/* styled */.z)(SvgIcon_es/* SvgIcon */.l)(SearchRecent_templateObject1());
const SearchRecent = (param)=>{
    let { histories , onRemoveSearchHistories , onSearch , selected , onHoverItem  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchRecent_StyledSearchTitle, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_es/* Text */.x, {
                        fontWeight: "500",
                        textTransform: "uppercase",
                        color: "#82869E",
                        children: (0,i18n.t)("Lịch sử t\xecm kiếm")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRemoveHistory, SearchRecent_objectSpreadProps(SearchRecent_objectSpread({
                        onClick: onRemoveSearchHistories
                    }, (0,helper_es/* getTrackingData */.O)({
                        isTrackContent: true,
                        regionName: "recentSearch",
                        contentName: "clearHistorySearch",
                        target: "searchProduct"
                    })), {
                        children: (0,i18n.t)("X\xf3a lịch sử")
                    }))
                ]
            }),
            histories.map((history, index)=>{
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(StyledSearchItem, SearchRecent_objectSpreadProps(SearchRecent_objectSpread({
                    onClick: ()=>onSearch(history),
                    selected: index === selected,
                    onMouseEnter: ()=>onHoverItem(index)
                }, (0,helper_es/* getTrackingData */.O)({
                    isTrackContent: true,
                    regionName: "recentSearch",
                    contentName: history.query,
                    target: "searchProductResult",
                    payload: JSON.stringify({
                        screenName: "searchProduct",
                        index
                    })
                })), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIcon, {
                            name: "time-outline",
                            size: 20
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                margin: "0 0.6rem"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_es/* Text */.x, {
                                    maxLines: 1,
                                    children: history === null || history === void 0 ? void 0 : history.query
                                }),
                                !!(history === null || history === void 0 ? void 0 : history.categoryId) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCategoryName, {
                                    children: [
                                        "Trong ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "cat-name",
                                            children: history.categoryName
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }), index);
            })
        ]
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Button/Button.es.js + 1 modules
var Button_es = __webpack_require__(24122);
;// CONCATENATED MODULE: ./components/desktop/organisms/SearchList.tsx
function SearchList_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SearchList_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SearchList_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SearchList_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function SearchList_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        SearchList_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function SearchList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SearchList_templateObject() {
    const data = SearchList_taggedTemplateLiteral([
        "\n  min-width: 20px;\n"
    ]);
    SearchList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SearchList_templateObject1() {
    const data = SearchList_taggedTemplateLiteral([
        "\n  .button-text {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n"
    ]);
    SearchList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SearchList_templateObject2() {
    const data = SearchList_taggedTemplateLiteral([
        "\n  text-overflow: ellipsis;\n"
    ]);
    SearchList_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







const SearchList_StyledSearchItem = styled_es/* styled.div */.z.div((props)=>"\n  display: flex;\n  padding: 0.6rem;\n  cursor: pointer;\n  border-radius: 8px;\n  align-items: center;\n  justify-content: ".concat(props.isSuggestProduct ? "space-between" : "none", " ;\n  background: ").concat(props.selected ? "#f5f5f5" : "#fff", ";\n  border-bottom: 1px solid #f4f4f4;\n"));
const SearchList_StyledCategoryName = styled_es/* styled.div */.z.div((props)=>"\n  color: #82869E;\n  font-size: 13px;\n  .cat-name {\n    color: ".concat(props.theme.brand.primary, ";\n  }\n"));
const SearchList_StyledIcon = (0,styled_es/* styled */.z)(SvgIcon_es/* SvgIcon */.l)(SearchList_templateObject());
const StyledButton = (0,styled_es/* styled */.z)(Button_es/* Button */.z)(SearchList_templateObject1());
const StyledTextSuggestion = (0,styled_es/* styled */.z)(Text_es/* Text */.x)(SearchList_templateObject2());
const SearchList = (param)=>{
    let { suggestions , onSearch , onHoverItem , selected , onAddToCart , onRedirectDetailProduct , isSuggestProduct =false  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: suggestions.map((s, index)=>{
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(SearchList_StyledSearchItem, SearchList_objectSpreadProps(SearchList_objectSpread({
                onClick: ()=>{
                    return !isSuggestProduct ? onSearch(s) : onRedirectDetailProduct(s === null || s === void 0 ? void 0 : s.sku);
                },
                selected: index === selected,
                onMouseEnter: ()=>onHoverItem(index),
                isSuggestProduct: isSuggestProduct
            }, (0,helper_es/* getTrackingData */.O)({
                isTrackContent: true,
                regionName: "searchSuggestion",
                contentName: s.query,
                target: "searchProductResult",
                payload: JSON.stringify({
                    screenName: "searchProduct",
                    index
                })
            })), {
                children: [
                    isSuggestProduct && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    margin: "0 0.6rem",
                                    flex: 1,
                                    overflow: "hidden"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTextSuggestion, {
                                    maxLines: 1,
                                    children: s === null || s === void 0 ? void 0 : s.highlight
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    onAddToCart(s);
                                },
                                variant: "secondary",
                                size: "s",
                                children: (0,i18n.t)("Th\xeam v\xe0o giỏ h\xe0ng")
                            })
                        ]
                    }),
                    !isSuggestProduct && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchList_StyledIcon, {
                                name: "search",
                                size: 20
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    margin: "0 0.6rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_es/* Text */.x, {
                                        maxLines: 1,
                                        children: s === null || s === void 0 ? void 0 : s.query
                                    }),
                                    !!(s === null || s === void 0 ? void 0 : s.categoryId) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchList_StyledCategoryName, {
                                        children: [
                                            "Trong ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cat-name",
                                                children: s.categoryName
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }), index);
        })
    });
};

// EXTERNAL MODULE: ./constants/local.ts
var local = __webpack_require__(65569);
// EXTERNAL MODULE: ../../packages/tracking/dist/cart.es.js
var cart_es = __webpack_require__(46586);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-46f73e5ea2/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(17016);
;// CONCATENATED MODULE: ./components/desktop/organisms/SearchBar.tsx
function SearchBar_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SearchBar_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SearchBar_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SearchBar_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SearchBar_templateObject() {
    const data = SearchBar_taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    SearchBar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SearchBar_templateObject1() {
    const data = SearchBar_taggedTemplateLiteral([
        "\n  border: 1px solid #eaeaea;\n"
    ]);
    SearchBar_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SearchBar_templateObject2() {
    const data = SearchBar_taggedTemplateLiteral([
        "\n  position: absolute;\n  background: #fff;\n  width: 120%;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.1);\n  padding: 0.5rem 0.8rem;\n  z-index: 1000;\n  display: ",
        ";\n"
    ]);
    SearchBar_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}













const SearchBarWrapper = emotion_styled_browser_esm/* default.div */.Z.div(SearchBar_templateObject());
const StyledSearchBar = (0,emotion_styled_browser_esm/* default */.Z)(SearchBar_es/* SearchBar */.E)(SearchBar_templateObject1());
const SearchSuggestion = emotion_styled_browser_esm/* default.div */.Z.div(SearchBar_templateObject2(), (props)=>props.show ? "block" : "none");
const SearchBar = ()=>{
    const router = (0,next_router.useRouter)();
    const { 0: visible , 1: setVisible  } = (0,react.useState)(false);
    const { 0: selectedSuggestion , 1: setSelectedSuggestion  } = (0,react.useState)(null);
    const { keyword , setKeyword , histories , suggestions , removeSearchHistories , onSearch , isSuggestProduct , onRedirectDetailProduct , addToCart ,  } = (0,useSearchSuggestions/* useSearchSuggestions */.f)();
    const { terms , setStartCallApi  } = (0,PopularKeywordContext/* usePopularKeyword */.y)();
    const { 0: input , 1: setInput  } = (0,react.useState)(keyword || "");
    const showHistories = !(keyword === null || keyword === void 0 ? void 0 : keyword.trim()) && histories.length > 0;
    const showSuggestions = (keyword === null || keyword === void 0 ? void 0 : keyword.trim()) && suggestions.length > 0;
    const showRecommendedKeywords = !(keyword === null || keyword === void 0 ? void 0 : keyword.trim()) && terms.length > 0;
    const handleSearch = (keywordObj)=>{
        onSearch(keywordObj);
        setVisible(false);
    };
    const onKeyUp = (e)=>{
        if (e.keyCode === 13) {
            if (!visible || selectedSuggestion === null) {
                !!(input === null || input === void 0 ? void 0 : input.trim()) && handleSearch({
                    query: input.trim()
                });
                return;
            }
            if (showHistories || showSuggestions && !isSuggestProduct) {
                const searchParam = showHistories ? histories[selectedSuggestion] : suggestions[selectedSuggestion];
                handleSearch(searchParam);
                return;
            }
            if (showSuggestions && isSuggestProduct) {
                var ref;
                onRedirectDetailProduct((ref = suggestions[selectedSuggestion]) === null || ref === void 0 ? void 0 : ref.sku);
                return;
            }
        }
    };
    const handleNavigateSearchResult = (ev)=>{
        if (visible && (ev.keyCode === local/* ARROW_KEY_UP */.rw || ev.keyCode === local/* ARROW_KEY_DOWN */.sf)) {
            ev.preventDefault();
            if (!showSuggestions && !showHistories) return;
            const currentList = showHistories ? histories : suggestions;
            const length = currentList.length;
            if (selectedSuggestion === null) {
                setSelectedSuggestion(0);
                setInput(currentList[0].query);
            } else {
                if (ev.keyCode === local/* ARROW_KEY_UP */.rw) {
                    if (selectedSuggestion <= 0) {
                        setSelectedSuggestion(length - 1);
                        setInput(currentList[length - 1].query);
                    } else {
                        setSelectedSuggestion((prev)=>{
                            setInput(currentList[prev - 1].query);
                            return prev - 1;
                        });
                    }
                } else if (ev.keyCode === local/* ARROW_KEY_DOWN */.sf) {
                    if (selectedSuggestion >= length - 1) {
                        setSelectedSuggestion(0);
                        setInput(currentList[0].query);
                    } else {
                        setSelectedSuggestion((prev)=>{
                            setInput(currentList[prev + 1].query);
                            return prev + 1;
                        });
                    }
                }
            }
        }
    };
    (0,react.useEffect)(()=>{
        var ref, ref1;
        const k = router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : (ref1 = ref.query) === null || ref1 === void 0 ? void 0 : ref1.toString();
        setSelectedSuggestion(null);
        const inputKeyword = k || "";
        setInput(inputKeyword);
        setKeyword(inputKeyword);
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchBarWrapper, {
        onMouseLeave: ()=>setVisible(false),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSearchBar, {
                onChange: (e)=>{
                    if (!visible) setVisible(true);
                    setSelectedSuggestion(null);
                    setInput(e.target.value);
                    setKeyword(e.target.value);
                },
                onKeyUp: onKeyUp,
                onClickInput: ()=>{
                    (0,cart_es/* trackManually */.gu)("searchBox", "headerBar", "searchProduct", JSON.stringify(SearchBar_objectSpread({
                        searchKeyword: input ? input.trim() : ""
                    },  true ? {
                        href: window.location.href,
                        url: window.location.href
                    } : 0)));
                    setVisible(true);
                    setStartCallApi(true);
                },
                value: input,
                placeholder: (0,i18n.t)("Nhập từ kho\xe1 cần t\xecm"),
                onClickIcon: ()=>input && input.trim() && handleSearch({
                        query: input
                    }),
                onKeyDown: handleNavigateSearchResult
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchSuggestion, {
                show: visible && (showHistories || showSuggestions || showRecommendedKeywords),
                children: [
                    showHistories && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchRecent, {
                        selected: selectedSuggestion,
                        histories: histories,
                        onRemoveSearchHistories: removeSearchHistories,
                        onSearch: handleSearch,
                        onHoverItem: setSelectedSuggestion
                    }),
                    showSuggestions && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchList, {
                        suggestions: suggestions,
                        onRedirectDetailProduct: onRedirectDetailProduct,
                        onHoverItem: setSelectedSuggestion,
                        selected: selectedSuggestion,
                        onAddToCart: (product)=>addToCart(product),
                        onSearch: handleSearch,
                        isSuggestProduct: isSuggestProduct
                    }),
                    showRecommendedKeywords && /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendedKeyword, {
                        onClick: (k)=>handleSearch({
                                query: k
                            }),
                        popularKeywords: terms
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 4952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ UserProfileHeader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20348);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(53769);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89703);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29556);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(45000);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(88155);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(76609);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(50290);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(37753);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(32762);
/* harmony import */ var _teko_ecommerce__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22236);
/* harmony import */ var _teko_auth_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18678);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28247);
/* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(67989);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17016);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24122);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88384);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(71323);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(71182);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(39427);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(55140);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86324);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  width: 36px;\n  height: 36px;\n  margin: 5px 0 4px 0;\n  &.vertical-avatar {\n    width: 30px;\n    height: 30px;\n    margin: 3px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  border-radius: 50%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  width: auto;\n  z-index: 9;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  background-color: #fff;\n  border-radius: 4px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  width: 250px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 0.5rem;\n  display: flex;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  width: 44px;\n  margin-right: 0.5rem;\n  img {\n    width: 100%;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _taggedTemplateLiteral([
        "\n  .name {\n    font-size: 1rem;\n    margin-bottom: 0;\n  }\n  .extra {\n    font-size: 0.9rem;\n    font-weight: 400;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = _taggedTemplateLiteral([
        "\n  height: 2rem;\n  width: 100%;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 10px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = _taggedTemplateLiteral([
        "\n  min-width: 100px;\n  height: 36px;\n  padding: 0 20px;\n  margin-left: 8px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = _taggedTemplateLiteral([
        "\n  min-width: 100px;\n  height: 36px;\n  padding: 0 20px;\n  margin-right: 8px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = _taggedTemplateLiteral([
        "\n  min-width: 90px;\n  padding: 0.365rem 0.75rem;\n  align-self: stretch;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  :before {\n    content: ' ';\n    width: 30px;\n    height: 30px;\n    border-radius: 15px;\n    background: rgb(236, 236, 236);\n    background: linear-gradient(\n      90deg,\n      rgba(236, 236, 236, 1) 0%,\n      rgba(227, 227, 227, 1) 100%\n    );\n  }\n  .title {\n    width: 60px;\n    height: 8px;\n    margin-top: 9px;\n    border-radius: 4px;\n    background: rgb(236, 236, 236);\n    background: linear-gradient(\n      90deg,\n      rgba(236, 236, 236, 1) 0%,\n      rgba(227, 227, 227, 1) 100%\n    );\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}












const Avatar = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject());
const AvatarImage = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"].img */ .Z.img(_templateObject1());
const StyledDropdown = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .Dropdown */ .L)(_templateObject2());
const DropdownContent = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject3());
const BriefUserPanel = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject4());
const UserAvatar = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject5());
const UserInfo = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject6());
const StyledButton = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z)(_templateObject7());
const ButtonWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject8());
const ModalAction = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject9());
const AcceptButton = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z)(_templateObject10());
const DeclineButton = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z)(_templateObject11());
const SigningButton = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject12());
const ProfileLink = (param)=>{
    let { icon , text , href , regionName , contentName , onClick  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .CustomLink */ .x, {
        href: href,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ecommerce__WEBPACK_IMPORTED_MODULE_6__/* .ListTile */ .x, _objectSpread({
            leading: icon,
            title: text,
            numberOfLine: 2,
            onClick: onClick
        }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_7__/* .getTrackingData */ .O)({
            isTrackContent: true,
            regionName,
            contentName
        })))
    });
};
const UserProfileHeader = (param)=>{
    let { vertical =false , customProfile , profileLinks  } = param;
    if (customProfile) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: customProfile
    });
    const { user: userProfile , loading: profileLoading , authService  } = (0,_teko_auth_react__WEBPACK_IMPORTED_MODULE_8__/* .useAuth */ .a)();
    const { notificationAppId  } = (0,contexts__WEBPACK_IMPORTED_MODULE_9__/* .useTenantConfig */ .Wx)();
    const { notificationService  } = (0,contexts__WEBPACK_IMPORTED_MODULE_10__/* .useServices */ .Su)();
    const { 0: dropdownOpen , 1: setDropdownOpen  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: showLogoutConfirmModal , 1: setShowLogoutConfirmModal  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const toggle = ()=>setDropdownOpen((prevState)=>!prevState);
    const onLogin = ()=>authService.login();
    if (profileLoading) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SigningButton, {
            className: "button",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "title"
            })
        });
    }
    if (!(userProfile === null || userProfile === void 0 ? void 0 : userProfile.userId)) {
        return vertical ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_style__WEBPACK_IMPORTED_MODULE_11__/* .NavigationButton */ .W, _objectSpreadProps(_objectSpread({
            className: "button",
            onClick: onLogin,
            style: {
                flexDirection: "column"
            }
        }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_7__/* .getTrackingData */ .O)({
            isTrackContent: true,
            regionName: "headerBar",
            contentName: "loginIcon"
        })), {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_12__/* .AccountOutlined */ .y, {
                    size: 36,
                    color: "textSecondary"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__/* .Body */ .uT, {
                    level: 2,
                    weight: "medium",
                    color: "textSecondary",
                    className: "title",
                    children: (0,i18n__WEBPACK_IMPORTED_MODULE_14__.t)("Đăng nhập")
                })
            ]
        })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_style__WEBPACK_IMPORTED_MODULE_11__/* .NavigationButton */ .W, _objectSpreadProps(_objectSpread({
            onClick: onLogin
        }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_7__/* .getTrackingData */ .O)({
            isTrackContent: true,
            regionName: "headerBar",
            contentName: "loginIcon"
        })), {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_12__/* .AccountOutlined */ .y, {
                    size: 36,
                    color: "textSecondary"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "text-left ml-6",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__/* .Body */ .uT, {
                            level: 2,
                            weight: "medium",
                            color: "textSecondary",
                            className: "title",
                            children: (0,i18n__WEBPACK_IMPORTED_MODULE_14__.t)("Đăng nhập")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__/* .Body */ .uT, {
                            level: 2,
                            weight: "medium",
                            color: "textSecondary",
                            className: "title",
                            children: (0,i18n__WEBPACK_IMPORTED_MODULE_14__.t)("Đăng k\xfd")
                        })
                    ]
                })
            ]
        }));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ui__WEBPACK_IMPORTED_MODULE_15__/* .Modal */ .u, {
                show: showLogoutConfirmModal,
                size: "sm",
                onHide: ()=>setShowLogoutConfirmModal(false),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_16__/* .ModalHeader */ .x, {
                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_14__.t)("Đăng xuất")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_17__/* .ModalBody */ .f, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: (0,i18n__WEBPACK_IMPORTED_MODULE_14__.t)("Bạn c\xf3 chắc chắn muốn đăng xuất kh\xf4ng?")
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_18__/* .ModalFooter */ .m, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ModalAction, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DeclineButton, {
                                    variant: "ghost",
                                    onClick: ()=>setShowLogoutConfirmModal(false),
                                    children: (0,i18n__WEBPACK_IMPORTED_MODULE_14__.t)("Kh\xf4ng")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AcceptButton, {
                                    variant: "primary",
                                    onClick: ()=>{
                                        (0,helpers__WEBPACK_IMPORTED_MODULE_19__/* .onSignOut */ .U3)(authService, notificationService, notificationAppId, window.location.origin);
                                        setShowLogoutConfirmModal(false);
                                    },
                                    children: (0,i18n__WEBPACK_IMPORTED_MODULE_14__.t)("C\xf3")
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledDropdown, _objectSpreadProps(_objectSpread({
                isOpen: dropdownOpen,
                toggle: toggle,
                toggleType: "hover",
                onHide: ()=>setDropdownOpen(false)
            }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_7__/* .getTrackingData */ .O)({
                isTrackContent: true,
                regionName: "headerBar",
                contentName: "profileIcon"
            })), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_20__/* .DropdownToggle */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_style__WEBPACK_IMPORTED_MODULE_11__/* .NavigationButton */ .W, {
                            className: vertical ? "button" : "",
                            style: vertical ? {
                                flexDirection: "column"
                            } : {
                                flexDirection: "row"
                            },
                            children: [
                                userProfile.avatar ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Avatar, {
                                    className: vertical ? "vertical-avatar" : "",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AvatarImage, {
                                        src: userProfile.avatar,
                                        "aria-label": "Current User Avatar"
                                    })
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_12__/* .AccountOutlined */ .y, {
                                    size: 36,
                                    color: "textSecondary"
                                }),
                                vertical ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__/* .Body */ .uT, {
                                    level: 2,
                                    weight: "medium",
                                    color: "textSecondary",
                                    className: "title",
                                    children: userProfile.name || userProfile.telephone
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "text-left ml-12",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__/* .Body */ .uT, {
                                            level: 2,
                                            weight: "medium",
                                            color: "textSecondary",
                                            className: "title",
                                            children: (0,i18n__WEBPACK_IMPORTED_MODULE_14__.t)("Xin ch\xe0o,")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__/* .Body */ .uT, {
                                            level: 2,
                                            weight: "medium",
                                            color: "textSecondary",
                                            className: "title",
                                            children: userProfile.name || userProfile.telephone
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_21__/* .DropdownMenu */ .h, {
                        placement: "bottom",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(DropdownContent, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(BriefUserPanel, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UserAvatar, {
                                            children: userProfile.avatar ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: userProfile.avatar,
                                                alt: "Avatar"
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_12__/* .AccountOutlined */ .y, {
                                                size: 36,
                                                color: "textSecondary"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(UserInfo, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                    className: "name",
                                                    children: userProfile.name
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                    className: "extra",
                                                    children: userProfile.email || userProfile.telephone
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                profileLinks && profileLinks.map((profileLink)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProfileLink, {
                                        icon: profileLink.icon,
                                        href: profileLink.href,
                                        text: profileLink.text,
                                        contentName: profileLink.contentName,
                                        regionName: profileLink.regionName,
                                        onClick: ()=>setDropdownOpen(false)
                                    }, profileLink.href)),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonWrapper, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledButton, _objectSpreadProps(_objectSpread({
                                        onClick: ()=>{
                                            setDropdownOpen(false);
                                            setShowLogoutConfirmModal(true);
                                        },
                                        variant: "primary"
                                    }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_7__/* .getTrackingData */ .O)({
                                        isTrackContent: true,
                                        regionName: "headerBar",
                                        contentName: "logOut"
                                    })), {
                                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_14__.t)("Đăng xuất")
                                    }))
                                })
                            ]
                        })
                    })
                ]
            }))
        ]
    });
};


/***/ }),

/***/ 67989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ NavigationButton; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17016);

const NavigationButton = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .Z.div((param)=>{
    let { theme  } = param;
    return "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  min-width: 90px;\n  padding: .365rem .75rem;\n  font-size: 13px;\n  position: relative;\n  cursor: pointer;\n  font-weight: 500;\n  color: ".concat(theme.colors.textSecondary, ";\n  a {\n    text-decoration: none;\n    color: unset;\n  }\n  &:hover {\n    color: ").concat(theme.colors.primary500, " !important;\n    > :not(.noti) path {\n      fill: ").concat(theme.colors.primary500, ";\n    }\n    > .noti path{\n      stroke: ").concat(theme.colors.primary500, ";\n    }\n    .title, .text-left .title{\n      color: ").concat(theme.colors.primary500, ";\n    }\n    .text-left {\n      text-align: left;\n    }\n  }\n  ");
});


/***/ }),

/***/ 91862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useSearchSuggestions; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55140);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74034);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63438);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46586);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96050);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}





const useSearchSuggestions = function() {
    let { numberOfHistories =5 , limitKeywords  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { isMobile  } = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useGlobalData */ .U5)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const searchHistoryKey = "".concat(isMobile ? "MOBILE" : "DESKTOP", "_SEARCH_HISTORY");
    const initKeyword = router.query.query || "";
    const { onAddSingleItem , onRequestItemSku  } = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useCartV2 */ .T)();
    const { 0: keyword , 1: setKeyword  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initKeyword);
    const { 0: histories , 1: setHistories  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]);
    const { result: suggestions , isSuggestProduct  } = (0,hooks__WEBPACK_IMPORTED_MODULE_4__/* .useKeywords */ .N)(keyword, limitKeywords);
    const getSearchHistory = function() {
        let count = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 5;
        if (typeof localStorage !== "undefined") {
            const historyStorage = localStorage.getItem(searchHistoryKey);
            if (historyStorage) {
                const data = JSON.parse(historyStorage);
                return (data || []).reverse().splice(0, count);
            }
            return [];
        }
        return [];
    };
    const saveSearchHistory = (keyword)=>{
        const historyStorage = localStorage.getItem(searchHistoryKey);
        if (!historyStorage) {
            localStorage.setItem(searchHistoryKey, JSON.stringify([
                keyword
            ]));
            return;
        }
        let historyArr = JSON.parse(historyStorage);
        historyArr = historyArr.filter((item)=>JSON.stringify(item) !== JSON.stringify(keyword));
        historyArr = [
            ...historyArr,
            keyword
        ];
        localStorage.setItem(searchHistoryKey, JSON.stringify(historyArr));
        setHistories(getSearchHistory(numberOfHistories));
    };
    const removeSearchHistories = ()=>{
        if (typeof localStorage !== "undefined") {
            localStorage.setItem(searchHistoryKey, JSON.stringify([]));
            setHistories([]);
        }
    };
    const onSearch = (keywordObj)=>{
        saveSearchHistory(keywordObj);
        let targetPath = null;
        if (router.query.query) {
            targetPath = {
                pathname: "/search",
                query: _objectSpread({
                    router: "productListing",
                    query: keywordObj.query
                }, !!keywordObj.categoryId ? {
                    masterCategoryIds: keywordObj.categoryId
                } : {})
            };
            router.replace(targetPath).then(()=>window.scrollTo(0, 0));
        } else {
            targetPath = {
                pathname: "/search",
                query: _objectSpread({
                    router: "productListing",
                    query: keywordObj.query
                }, !!keywordObj.categoryId ? {
                    masterCategoryIds: keywordObj.categoryId
                } : {})
            };
            router.push(targetPath).then(()=>window.scrollTo(0, 0));
        }
        const targetUrl = new URL(window.location.origin);
        targetUrl.pathname = targetPath.pathname;
        targetUrl.search = new URLSearchParams(targetPath.query).toString();
        (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_5__/* .trackManually */ .gu)("searchButton", "headerBar", "searchProductResult", JSON.stringify({
            searchKeyword: keywordObj.query,
            href: window.location.href,
            url: targetUrl.href
        }));
    };
    const addToCart = async (product)=>{
        if (!!product.sku) {
            await onAddSingleItem({
                sku: product.sku,
                quantity: 1
            }, true);
        } else {
            await onRequestItemSku(product.highlight);
        }
    };
    const onRedirectDetailProduct = (sku)=>{
        if (sku) {
            router.push("/products/".concat(sku));
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (numberOfHistories > 0) {
            setHistories(getSearchHistory(numberOfHistories));
        } else setHistories([]);
    }, [
        numberOfHistories
    ]);
    return {
        keyword,
        setKeyword,
        histories,
        removeSearchHistories,
        suggestions,
        onSearch,
        onRedirectDetailProduct,
        isSuggestProduct,
        addToCart
    };
};


/***/ }),

/***/ 9738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useUnreadNotification; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63438);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55140);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86324);
/* harmony import */ var _teko_auth_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18678);




const useUnreadNotification = ()=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const { user  } = (0,_teko_auth_react__WEBPACK_IMPORTED_MODULE_2__/* .useAuth */ .a)();
    const { notificationAppId  } = (0,_contexts__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)();
    const { 0: unreadNotification , 1: setUnreadNotification  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0);
    const { notificationService  } = (0,_contexts__WEBPACK_IMPORTED_MODULE_4__/* .useServices */ .Su)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const token = localStorage.getItem("fcmToken");
        const unreadParams = {
            app_id: notificationAppId,
            ignore_pending_send: 0,
            token: token !== null && token !== void 0 ? token : undefined
        };
        if (notificationAppId) {
            notificationService.unreadCount(unreadParams).then((data)=>{
                if (data) {
                    setUnreadNotification(data.count);
                }
            });
        }
    }, [
        user === null || user === void 0 ? void 0 : user.userId,
        router,
        notificationAppId
    ]);
    return {
        unreadNotification
    };
};


/***/ })

}]);